import { render, staticRenderFns } from "./entry_reviewCity.vue?vue&type=template&id=21f4a8ca&scoped=true"
import script from "./entry_reviewCity.vue?vue&type=script&lang=js"
export * from "./entry_reviewCity.vue?vue&type=script&lang=js"
import style0 from "./entry_reviewCity.vue?vue&type=style&index=0&id=21f4a8ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f4a8ca",
  null
  
)

export default component.exports